import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import { version } from "../utils"
//pass new generated access token here
export const API_URL_PUBLIC = process.env.REACT_APP_API_URL;
export const API_URL = `${API_URL_PUBLIC}/admin`
const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    version: version.admin
  }
})

const axiosApiPublic = axios.create({
  baseURL: API_URL_PUBLIC,
  headers: {
    version: version.storefront
  }
})

// API public chi tiết đơn ẩn thông tin khách nếu không phải chủ đơn -> gửi token admin để xem đầy đủ
axiosApiPublic.interceptors.request.use((config) => {
  const token = accessToken()
  if (token) {
    config.headers.authentication = token
  }
  return config
})

export const setToken = () => axiosApi.defaults.headers.common["authentication"] = accessToken()
setToken()

axiosApi.interceptors.response.use(
  response => response?.data,
  error => {
    if (error?.response?.status === 401) {
      if (window.location.pathname !== '/login') {
        localStorage.clear();
        window.location.href = '/login'
        return Promise.reject(error.response)
      }
    }
    if (error?.response?.status === 801) {
      window.location.reload();
      return Promise.reject('Phiên bản hiện tại không hợp lệ. Tải lại trang để tiếp tục sử dụng.')
    }
    return Promise.reject(error?.response?.data)
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config })
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
}

export async function getPublic(url, config = {}) {
  return await axiosApiPublic.get(url, { ...config })
}

export async function postPublic(url, config = {}) {
  return await axiosApiPublic.post(url, { ...config })
}
